import processHtmlAttributes from "../../common/html-attributes";

static var ignoredAttributes = ["type", "number"];
$ var number = Math.round(input.number);

<if(number > 0)>
    <span
        ...processHtmlAttributes(input, ignoredAttributes)
        role=(input.type !== "menu" && input.type !== "icon" && "img")
        class=["badge", input.class]>
        ${number > 99 ? "99+" : number}
    </span>
</if>
